export const TERMS_AND_CONDITIONS_LINK = 'https://explore.wolt.com/campaigns/merchant-terms-and-conditions';
export const SELF_DELIVERY_VENUES_NOT_ALLOWED = 'Promotions not allowed for self-delivery and flexible fulfillment';
export const TERMS_AND_CONDITIONS_LINK_SUMMER_CONTEST = 'https://explore.wolt.com/woltads-contest-terms-and-conditions';
